<template>
  <div>
    <v-snackbar
      v-for="(item, index) in items"
      :key="index"
      v-model="item.state"
      :top="item.y === 'top'"
      :bottom="item.y === 'bottom'"
      :left="item.x === 'left'"
      :right="item.x === 'right'"
      :color="item.color"
      :timeout="item.timeout"
      :outlined="item.outlined"
      :absolute="item.absolute || false"
      :multi-line="item.multiline"
      :vertical="item.vertical"
    >
      {{ item.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          :dark="!item.outlined"
          text
          v-bind="attrs"
          @click="item.state = false"
        >
          {{ item.closeBtnText || 'Close' }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  name: 'SnackbarsBroker',
  props: {
    defaultX: {
      type: String,
      default: null
    },
    defaultY: {
      type: String,
      default: null
    },
    defaultColor: {
      type: String,
      default: null
    },
    defaultTimeout: {
      type: Number,
      default: 6000
    }
  },
  data () {
    return {
      items: []
    }
  },
  computed: {
    itemsStringified () {
      return JSON.stringify(this.items)
    }
  },
  watch: {
    itemsStringified () {
      this.cleanup()
    }
  },
  methods: {
    trigger (item) {
      const snackbar = {
        ...item,
        x: item.x || this.defaultX,
        y: item.y || this.defaultY,
        color: item.color || this.defaultColor,
        timeout: item.timeout || this.defaultTimeout,
        state: undefined
      }
      this.items.push(snackbar)
      this.$nextTick(() => {
        snackbar.state = true
      })
    },
    cleanup () {
      this.items = this.items.filter(item => item.state !== false)
    }
  },
  created () {
    this.$eh.$on('snackbar', this.trigger)
  },
  beforeDestroy () {
    this.$eh.$off('snackbar', this.trigger)
  }
}
</script>
